export class PatientAccessUpdateDataStruct {
    idPatient: number;
    idHealthUnit: number;
    zipCode: string;
    street: string;
    neighborhood: string;
    city: string;
    state: string;
    phone1: string;
    phone2: string;
    houseNumber: string;
    apartmentNumber: string;
    birthDate?: Date;
} 